import { Option } from '@zuto/atoms'
import { Address } from '../../repository/postcode-repository.types'
import { AddressDetails, AddressHistoryEntry } from '../../components/Questions/CardlessAddressHistoryQuestion/AddressHistoryContext'
import { AddressSituation, mapToAddressSituation } from '../AddressSituationMapper'

export const mapAddresses = (matches: Record<string, string>[]): Option[] => {
  const mapped: Option[] = []
  matches.forEach((address) => {
    if (address.Type === 'Address') {
      mapped.push({
        value: address.Id,
        label: `${address.Text}, ${address.Description}`
      })
    }
  })
  mapped.sort((a, b) => {
    if (a.label > b.label) {
      return 1
    }
    return (b.label > a.label) ? -1 : 0
  })
  return mapped
}

export const mapAddress = (address: Address): AddressDetails => ({
  flatNumber: address.SubBuilding,
  buildingNumber: address.BuildingNumber,
  buildingName: (!address.SubBuilding && !address.BuildingNumber && !address.BuildingName) ? address.Company : address.BuildingName,
  street: address.Street || address.Line2,
  town: address.District || address.City,
  county: address.Province,
  postcode: address.PostalCode
})

export interface AddressField {
  nameNumberField: string
  streetField: string
  townCityField: string
  countyField: string
  postCodeField: string
  yearsField: number
  monthsField: number
  addressOrderField: number
  residentialStatusField: AddressSituation
}

export const mapAddressEntryToFormAddress = (
  entry: AddressHistoryEntry,
  index: number
): AddressField => ({
  nameNumberField: (`${entry.addressDetails?.buildingNumber ?? ''} ${entry.addressDetails?.flatNumber ?? ''} ${entry.addressDetails?.buildingName ?? ''}`).trim().replace(/  +/g, ' ').substring(0, 50) || '',
  streetField: entry.addressDetails?.street || '',
  townCityField: entry.addressDetails?.town || '',
  countyField: entry.addressDetails?.county || '',
  postCodeField: entry.addressDetails?.postcode || '',
  yearsField: entry.lengthOfTime?.years ? parseInt(entry.lengthOfTime.years, 10) : 0,
  monthsField: entry.lengthOfTime?.months ? parseInt(entry.lengthOfTime.months, 10) : 0,
  addressOrderField: index + 1,
  residentialStatusField: mapToAddressSituation(entry.addressSituation || '')
})
